<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M41 7v11.77L19.2 40.58 7.41 28.85 29.25 7H41m1-3H28.84a2 2 0 00-1.42.58L4.58 27.44a2 2 0 000 2.83l13.21 13.14a2 2 0 002.82 0l22.81-22.82a2 2 0 00.58-1.41V6a2 2 0 00-2-2z"/><path d="M32.06 14.56a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5m0-2a3.5 3.5 0 103.5 3.5 3.5 3.5 0 00-3.5-3.5z"/></svg>